import type { CourierParcelReport } from './courier-tracking';

export interface CourierDeliveryReview {
  shipment_id: string;
  digest: string;
  booking_id: string | null;
  booking_revision: number | null;
  provider: string | null;
  tracking_number: string | null;
  check_id: string | null;
  checked_at: string | null;
  blockers: string[];
  parcels: Array<{ parcel: number; tracking_number: string; report: CourierParcelReport | null;
    items: Array<{ order_item_id: number; title: string; quantity: number; received: number }> }>;
}
export interface CourierDeliveryDraft { quantities: Record<string, string>; reference: string }
export interface CourierDeliveryEvidence {
  digest: string; booking_id: string; booking_revision: number; check_id: string | null;
  confirmed: true; reference: string;
  parcels: Array<{ parcel: number; items: Array<{ order_item_id: number; quantity: number }> }>;
}
export const emptyCourierDeliveryDraft: CourierDeliveryDraft = { quantities: {}, reference: '' };
export function validCourierDeliveryDraft(value: unknown): value is CourierDeliveryDraft {
  const v = value as CourierDeliveryDraft;
  return !!v && typeof v === 'object' && !Array.isArray(v) && typeof v.reference === 'string' && v.reference.length <= 500
    && !!v.quantities && typeof v.quantities === 'object' && !Array.isArray(v.quantities)
    && Object.keys(v.quantities).length <= 2000 && Object.entries(v.quantities).every(([k, n]) => /^[1-9][0-9]*:[1-9][0-9]*$/.test(k) && typeof n === 'string' && n.length <= 20);
}
export function courierDeliverySelection(review: CourierDeliveryReview, draft: CourierDeliveryDraft) {
  const quantities: Record<number, string> = {};
  const parcels: CourierDeliveryEvidence['parcels'] = [];
  let error = '';
  for (const parcel of review.parcels) {
    const items: CourierDeliveryEvidence['parcels'][number]['items'] = [];
    for (const line of parcel.items) {
      const raw = draft.quantities[`${parcel.parcel}:${line.order_item_id}`] || '';
      const n = raw.trim() === '' ? 0 : Number(raw);
      if (!Number.isSafeInteger(n) || n < 0 || n > line.quantity - line.received) error = 'Enter received quantities within the remaining contents of each parcel.';
      else if (n > 0) {
        items.push({ order_item_id: line.order_item_id, quantity: n });
        quantities[line.order_item_id] = String(Number(quantities[line.order_item_id] || 0) + n);
      }
    }
    if (items.length) parcels.push({ parcel: parcel.parcel, items });
  }
  return { quantities, parcels, error };
}
